import styled, { css } from 'styled-components';
import { Text } from '@usealloy/component-library';

export const ServicesList = styled.div`
    padding: 24px 32px;
    display: flex;
    align-items: flex-start;
    flex-flow: wrap;
`;

interface StyledCircleProps {
  showCursor: boolean;
}

export const ServicesItem = styled.div<StyledCircleProps>`
    padding: 4px 0;
    flex: 1 1 50%;
    ${({ showCursor }) => (showCursor
    ? css`
        cursor: pointer
        `
    : '')}
`;

export const ServicesItemText = styled(Text)`
    && {
        text-decoration: underline;
        flex: 1;
        word-break: break-all;
    }
`;

export const NoDataText = styled(Text)`
    && {
        color: #bbbbbb;
        font-style: italic;
    }
`;

// Daffy's global `ul` reset (base.scss) zeroes padding and removes markers, so
// both are re-declared here to get bullets back.
export const ErrorAttributeList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-inline-start: 16px;
    list-style-type: disc;
`;
